<template>
  <div class="grid-intro-two-content" id="identidade-visual-grid-layouts" data-search-anchor>
    <div class="title-intro-two-wrapper">
      <h1 class="grid-intro-two-title-span">{{ gridIntroTwoTitleSpan }}</h1>
      <h1 class="grid-intro-two-title">{{ gridIntroTwoTitle }}</h1>
    </div>
    <div class="description-intro-two-wrapper">
      <div>
        <p class="grid-intro-two-description">{{ gridIntroTwoDescription1 }}</p>
      </div>

      <div>
        <p class="grid-intro-two-description">{{ gridIntroTwoDescription2 }}</p>
      </div>

      <div>
        <p class="grid-intro-two-description">{{ gridIntroTwoDescription3 }}</p>
      </div>

      <div>
        <p class="grid-intro-two-description">{{ gridIntroTwoDescription4 }}</p>
      </div>

      <div>
        <p class="grid-intro-two-description" style="margin-bottom: 1rem">
          {{ gridIntroTwoDescription5 }}
        </p>
      </div>
    </div>
    <div
      class="grid-intro-two-card-item"
      :style="{ backgroundImage: `url(${gridIntroTwoImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GridPageMixin from '@/mixins/grid-page-mixin'
import { GridPageStore } from '@/store/visual-identity-page/grid-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class GriIntroTwoSection extends Mixins(GridPageMixin) {
  gridPageStore: PageStoreContract = getModule(GridPageStore, this.$store)

  get gridIntroTwoTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get gridIntroTwoTitle(): string {
    return this.getElementText(2, 0)
  }

  get gridIntroTwoDescription1(): string {
    return this.getElementText(2, 1)
  }

  get gridIntroTwoDescription2(): string {
    return this.getElementText(2, 2)
  }

  get gridIntroTwoDescription3(): string {
    return this.getElementText(2, 3)
  }

  get gridIntroTwoDescription4(): string {
    return this.getElementText(2, 4)
  }

  get gridIntroTwoDescription5(): string {
    return this.getElementText(2, 5)
  }

  get gridIntroTwoImageSrc(): string {
    return this.getElementMedia(2, 6)
  }

  async getGridPage(): Promise<void> {
    await this.gridPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.gridPageStore.isLoading) {
      await this.getGridPage()
    }
  }
}
</script>

<style lang="scss">
.grid-intro-two-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-intro-two-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.grid-intro-two-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}
.grid-intro-two-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-intro-two-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.grid-intro-two-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  text-align: left;
  width: 430px;
}

.title-image {
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  padding-left: 3rem;
  width: 187px;
}

.grid-intro-two-card-item {
  position: relative;
  max-width: 1032px;
  width: 100%;
  height: 703px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-bottom: 2rem;
}

.button-grid-wrapper {
  display: flex;
  align-items: center;
  margin-top: 2rem;
  padding-bottom: 2rem;
}
</style>
